import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
} from '@angular/core';
import { DestinationsProvider } from '@prlw/core/destinations/destinations.provider';
import { Observable } from 'rxjs';
import {
  Destination,
  DestinationEntity,
} from '@prlw/core/destinations/destination.entity';
import { BuyProduct } from '@prlw/core/buy-product/buy-product.entity';
import { BuyProductController } from '@prlw/core/buy-product/buy-product.controller';
import { BuyProductStatus } from '@prlw/core/buy-product/buy-product-status.enum';
import { DestinationState } from '@prlw/core/destinations/destination.state';
import { InstrumentByShipmentDestinationService } from '@prlw/core/buy-product/instrument-by-shipment-destination.service';
import { Instrument } from '@prlw/core/monitor/instrument.entity';
import { MobileOverlayService } from '@prlw/libs/mobile-overlay/mobile-overlay.service';
import { DestinationsFilterMobileContainer } from '../destinations/destinations-filter-mobile/destinations-filter-mobile.container';

@Component({
  selector: 'prlw-buy-product',
  templateUrl: './buy-product.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [InstrumentByShipmentDestinationService],
})
export class BuyProductContainer implements OnDestroy {
  @Input() public instrument: Instrument | null = null;
  @Output()
  public readonly eventClose = new EventEmitter<void>();
  public readonly destinations$: Observable<DestinationEntity[]>;
  public readonly currentDestination$: Observable<Destination | null>;
  public readonly buyProductStatus$: Observable<BuyProductStatus>;

  constructor(
    private readonly destinationsProvider: DestinationsProvider,
    private readonly destinationState: DestinationState,
    private readonly buyProductController: BuyProductController,
    private readonly instrumentByShipmentDestinationService: InstrumentByShipmentDestinationService,
    private readonly mobileOverlayService: MobileOverlayService,
  ) {
    this.destinations$ = destinationsProvider.destinations$;
    this.currentDestination$ = destinationState.currentDestination$;
    this.buyProductStatus$ = this.buyProductController.buyProductStatus$;
  }

  public closeModal(): void {
    this.eventClose.emit();
  }

  public updateStationList(station: string): void {
    this.destinationsProvider.searchDestinations(station);
  }

  public buyRequest(product: BuyProduct): void {
    this.buyProductController.buyProduct(product);
  }

  public repeatBuyRequest(): void {
    this.buyProductController.setInit();
  }

  public setCurrentDestination(destination: Destination) {
    this.instrumentByShipmentDestinationService.setDestination(destination);
  }

  public ngOnDestroy(): void {
    this.buyProductController.setInit();
  }

  public handleOpenDestinationsOverlay() {
    this.mobileOverlayService.show(DestinationsFilterMobileContainer);
  }
}
